/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StatsOperationRecentIncidentActivityDto } from './StatsOperationRecentIncidentActivityDto';
import type { UserDto } from './UserDto';

export type StatsOperationRecentIncidentStatusChangeDto = (StatsOperationRecentIncidentActivityDto & {
    changedByUser?: UserDto;
    newStatus?: StatsOperationRecentIncidentStatusChangeDto.newStatus;
} & {
    changedByUser: UserDto;
    newStatus: StatsOperationRecentIncidentStatusChangeDto.newStatus;
});

export namespace StatsOperationRecentIncidentStatusChangeDto {

    export enum newStatus {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
